import React from "react";
import { CoursesCard } from "./CoursesCard";
import { CoursesUIProvider } from "./CoursesUIContext";

export function CoursesPage({ history }) {
  const coursesUIEvents = {
    openNewParentCoursePage: () => {
      history.push("/dersler/ekle");
    },
    openNewSubCoursePage: (parentId) => {
      history.push(`/dersler/ekle/${parentId}`);
    },
    openEditCoursePage: (id) => {
      history.push(`/dersler/duzenle/${id}`);
    },
  };
  
  return (
    <CoursesUIProvider coursesUIEvents={coursesUIEvents}>
      <CoursesCard />
    </CoursesUIProvider>
 );
}